<template>
  <div
    class="main-wrapper"
    ref="tooltip"
  >
    <div
      class="tooltip-wrapper"
      ref="tooltipContent"
      :style="contentStyle"
    >
      <div class="arrow"></div>
      <slot name="content"></slot>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    positionLeft: {
      type: Number,
      required: true,
    },
    positionTop: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      default: 208,
    },
  },
  data() {
    return {
      contentStyle: '',
      marginBottom: 15,
    };
  },
  mounted() {
    const { offsetHeight } = this.$refs.tooltip;
    const height = this.$refs.tooltipContent?.offsetHeight || 100;
    const top = offsetHeight + this.positionTop - height - this.marginBottom;
    const left = this.positionLeft - this.width/2;

    this.contentStyle = `top: ${top}px;` +
                          `left: ${left}px;` +
                          `height: ${height}px;` +
                          `width: ${this.width}px;`;
  },
};
</script>

<style scoped>
  .main-wrapper {
    z-index: 2;
    display: inline-block;
    position: absolute;
    width: 0;
    height: 0;
  }

  .tooltip-wrapper {
    position: relative;
    color: #ffffff;
    background: #223448;
    box-shadow: 0px 0px 3px rgba(34, 52, 72, 0.4);
    border-radius: 4px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }

  .arrow {
    position: absolute;
    height: 10px;
    background: #223448;
    bottom: -5px;
    transform: rotate(45deg);
    left: 47.66%;
    right: 47.34%;
  }
</style>
